<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <Header class="header"></Header>

    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
      <template v-slot:bottomButtom>
        <button type="button" class="btn_p" @click="test">
          동의함
        </button>
      </template>
    </MessagePop>

    <ConfirmPop v-if="confirmPop" @cancel="cancel" @confirm="confirm" @close="close">
      <p v-html="msg"></p>
    </ConfirmPop>

    <ConfirmPop v-if="confirmPop2" @cancel="cancel" @confirm="confirm">
      <p v-html="msg"></p>
      <template v-slot:btnArea>동의안함</template>
      <template v-slot:btnArea2>동의함</template>
    </ConfirmPop>

    <BottomPop v-if="bottomPop" @close="close">
      <p v-html="msg"></p>
    </BottomPop>

    <NoticePop v-if="noticePop" @close="close">
      <div class="tempArea pt190 pb190">임의영역</div>
    </NoticePop>

    <WebViewPop v-if="webViewPop" :pageName="pageName" @close="close">
      <div v-html="webView"></div>
    </WebViewPop>

    <SharePop v-if="sharePop" @close="close"></SharePop>

    <FindAddr v-if="findAddr" @callback="selectAddr" @close="close"></FindAddr>

    <OptionPop v-if="optionPop" @getOption="getOption" @close="close"></OptionPop>

    <CouponPop v-if="couponPop" @close="close"></CouponPop>

    <!-- <ChangePwdPop
      v-if="changePwdPop"
      :userId="userId"
      :token="token"
      @changeLater="changeLater"
      @close="close"
    ></ChangePwdPop>

    <InactiveAccountPop v-if="inactiveAccountPop" @activeAccount="activeAccount" @close="close"></InactiveAccountPop> -->

    <div id="content" style="padding-bottom: 92px;">
      <br />
      <br />
      <br />
      <br />
      <br />
      <button @click="openPop('messagePop')">1. Message(alert) 팝업</button>
      <br />
      <button @click="openPop('confirmPop')">2. Confirm 팝업</button>
      <br />
      <button @click="openPop('confirmPop2')">2-1. Confirm 팝업(버튼변경)</button>
      <br />
      <button @click="openPop('bottomPop')">3. Bottom 팝업</button>
      <br />
      <button @click="openPop('noticePop')">4. Notice 팝업</button>
      <br />
      <button @click="openPop('webViewPop')">5. WebView 팝업</button>
      <br />
      <button @click="openPop('sharePop')">6. Share 팝업</button>
      <br />
      <button @click="openPop('findAddr')">7. 주소검색 팝업</button>
      <br />
      <button @click="openPop('optionPop')">8. 옵션 팝업</button>
      <br />
      <button @click="openPop('couponPop')">9. 쿠폰 팝업</button>
      <br />
      <!-- <button @click="openPop('changePwdPop')">10. 비밀번호 90일 경과</button><br />
      <button @click="openPop('inactiveAccountPop')">11. 휴먼계정해지</button><br /> -->
    </div>

    <!-- <div id="content" style="padding-bottom: 92px;">
      <br /><br /><br /><br /><br />
      <button @click="popupOpen('messagePop', 'messagePop test', '', '', closeFunction)">1. Message(alert) 팝업</button><br />
      <button @click="popupOpen('confirmPop', 'confirmPop test', '', '', null, confirmFunction1, cancelFunction)">2. Confirm 팝업</button><br />
      <button @click="popupOpen('confirmPop', 'confirmPop test', '', '', null, confirmFunction2, cancelFunction)">2.5. Confirm 팝업</button><br />
      <button @click="popupOpen('bottomPop', 'bottomPop test')">3. Bottom 팝업</button><br />
      <button @click="popupOpen('noticePop', 'noticePop test')">4. Notice 팝업</button><br />
      <button @click="popupOpen('webViewPop', '', 'title', 'data')">5. WebView 팝업</button><br />
      <button @click="popupOpen('sharePop')">6. Share 팝업</button><br />
      <button @click="popupOpen('findAddr', '', '', '', null, null, null, selectAddr)">7. 주소검색 팝업</button><br />
      <button @click="popupOpen('optionPop')">8. 옵션 팝업</button><br />
      <button @click="popupOpen('couponPop')">9. 쿠폰 팝업</button><br />
      <button @click="popupOpen2('messagePop', 'messagePop test', 'OK')">10. 버튼명 변경 테스트</button><br />
    </div> -->

    <!-- <CommonPop
      v-if="openFlag"
      @close="popupClose"
      :popupFlags="popupFlag"
      :popCloseCallback="closeCallback"
      :popConfirmCallback="confirmCallback"
      :popCancelCallback="cancelCallback"
      :popAddrCallback="addrCallback"
      :popPageName="pageName"
      :webViewUrl="webView"
      :okBtnText="okBtnText"
    >
      <p v-html="msg"></p>
    </CommonPop> -->
  </div>
</template>

<script>
import ApiService from '@/common/api.service';
import BottomPop from '@/components/popup/BottomPop';
import ConfirmPop from '@/components/popup/ConfirmPop';
import MessagePop from '@/components/popup/MessagePop';
import NoticePop from '@/components/popup/NoticePop';
import WebViewPop from '@/components/popup/WebViewPop';
import SharePop from '@/components/popup/SharePop';
import FindAddr from '@/components/comm/FindAddr';
import OptionPop from '@/components/popup/OptionPop';
import CouponPop from '@/components/popup/CouponPop';
// import CommonPop from './CommonPop';
import { TERM_AGREE_CHECK } from '@/store/message.type.js';
// import popup from '@/../static/js/popup';

export default {
  name: 'popupTest',
  // mixins: [popup],
  components: {
    BottomPop,
    ConfirmPop,
    MessagePop,
    NoticePop,
    WebViewPop,
    SharePop,
    FindAddr,
    OptionPop,
    CouponPop,
    //CommonPop,
  },
  data() {
    return {
      headerTitle: '팝업테스트페이지',
      msg: TERM_AGREE_CHECK,
      webViewUrl: null,
      webViews: [],
      webView: null,
      pageName: null,
      messagePop: false,
      confirmPop: false,
      confirmPop2: false,
      bottomPop: false,
      noticePop: false,
      webViewPop: false,
      sharePop: false,
      findAddr: false,
      optionPop: false,
      couponPop: false,
    };
  },
  mounted() {
    //alert('test :: ' + JSON.stringify(this.popupTest));
    //CommonPop.methods.testFunction();
  },
  methods: {
    openPop(value) {
      switch (value) {
        case 'messagePop':
          this.msg = `<p class='tit'>푸시알림 설정</p><p>푸시알림 수신을 거부하였습니다.<br/>푸시알림 수신을 원하실경우 <span class="pointC1">[설정]</span>에서<br>변경 가능합니다.</p>`;
          this.messagePop = true;
          break;
        case 'confirmPop':
          this.confirmPop = true;
          break;
        case 'confirmPop2':
          this.confirmPop2 = true;
          break;
        case 'bottomPop':
          this.msg =
            TERM_AGREE_CHECK + TERM_AGREE_CHECK + TERM_AGREE_CHECK + TERM_AGREE_CHECK + TERM_AGREE_CHECK + TERM_AGREE_CHECK + TERM_AGREE_CHECK;
          this.bottomPop = true;
          break;
        case 'noticePop':
          this.noticePop = true;
          break;
        case 'webViewPop':
          this.getWebView();
          break;
        case 'sharePop':
          this.sharePop = true;
          break;
        case 'findAddr':
          this.findAddr = true;
          break;
        case 'optionPop':
          this.optionPop = true;
          break;
        case 'couponPop':
          this.couponPop = true;
          break;
        default:
          break;
      }
    },
    close() {
      this.messagePop = false;
      this.confirmPop = false;
      this.confirmPop2 = false;
      this.bottomPop = false;
      this.noticePop = false;
      this.webViewPop = false;
      this.sharePop = false;
      this.findAddr = false;
      this.optionPop = false;
      this.couponPop = false;
    },
    cancel() {
      this.confirmPop = false;
      this.confirmPop2 = false;
    },
    confirm() {
      alert('확인로직수행!');
      //this.confirmPop = false;
    },
    async getWebView() {
      // 해당페이지 웹뷰 url 리스트
      let webViews = await ApiService.service('GET', 'common/webView/WB000001');
      this.webViews = webViews.data.result;

      //this.webViewUrl = this.webViews[index].filePath;
      this.webViewUrl = 'http://localhost:3000/test1.html'; // 테스트
      this.pageName = this.webViews[0].pageName;

      await ApiService.service('GET', this.webViewUrl)
        .then(({ data }) => {
          //console.log(data);
          this.webView = data;
          this.webViewPop = true;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    selectAddr(data) {
      alert('콘솔 로그 확인!');
      if (data.popupFlag == 'findAddr') {
        console.log(data.zip);
        console.log(data.nadr1);
        console.log(data.nnmb);
        console.log(data.adr1);
      }

      // this.installInfo.addrPost = data.zip;
      // this.installInfo.addrRoad = data.nadr1;
      // this.installInfo.addrCode = data.nnmb;
      // this.installInfo.addrJibun = data.adr1;
    },
    getOption() {
      console.log('받은옵션 => ');
      this.optionPop = false;
    },
    // selectCoupon: function() {
    //   alert('test');
    // },
    // closeFunction: function() {
    //   alert('closeFunction');
    // },
    // confirmFunction1: function() {
    //   alert('confirmFunction1');
    // },
    // confirmFunction2: function() {
    //   alert('confirmFunction2');
    // },
    // cancelFunction: function() {
    //   alert('cancelFunction');
    // },
  },
};
</script>
